module.exports = __webpack_public_path__ + "static/img/mail-b01.6fd47f15.png";